<template>
  <div style="width: 95%; margin-left: 2%;">
    <apexchart height="650" type="scatter" :options="chartOptions" :series="chartOptions.series"></apexchart>
  </div>
</template>

<script>
import server from '../../api/server.vue'
import Vue from 'vue'

export default {
  name: 'WorkstationStateGraph',
  data: function() {
    return {
      items: [],
      isLoading : false,
      chartOptions: {
        chart: {
          type: "bar",
          stacked: false
        },
        dataLabels: {
          enabled: false
        },
        colors: ['#99C2A2', '#C5EDAC', '#66C7F4'],
        series: [
          {
            name: 'France',
            type: 'column',
            data: [21.1, 23, 33.1, 34, 44.1, 44.9, 56.5]
          },
          {
            name: 'Export',
            type: 'column',
            data: [10, 19, 27, 26, 34, 35, 40]
          },
          {
            name: 'Grand Export',
            type: 'column',
            data: [1.4, 2, 2.5, 1.5, 2.5, 2.8, 3.8]
          },
        ],
        stroke: {
          width: [4, 4, 4]
        },
        plotOptions: {
          bar: {
            columnWidth: '30%'
          }
        },
        xaxis: {
          categories: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']
        },
        tooltip: {
          shared: false,
          intersect: true,
          x: {
            show: false
          }
        },
        legend: {
          position: "top",
          offsetX: 40
        }
      },
    }
  },
  mounted () {
    // this.getData()
  },
  methods: {
    getData () {
      this.isLoading = true
      const todayMs = Date.now()
      this.chartOptions = {...this.chartOptions, ...{
        xaxis: {
          type: 'datetime',
          min: todayMs - (this.periodInDays * 24 * 3600 * 1000)
        }
      }}

      server.getAllStockScansFrom(this.periodInDays).then((res) => {
        this.items = res.data.filter((product) => (product.lead_time != null))
        let dataSerie = []
        this.items.forEach((item) => {
          if (item.lead_time) {
            let nbDay = Math.ceil((item.lead_time / (3600 * 24)))
            if (!isNaN(nbDay)) {
              dataSerie.push([item.scan_time, nbDay])
            }

            this.avgLeadTime += nbDay
            this.maxLeadTime = Math.max(nbDay, this.maxLeadTime)
            this.minLeadTime = Math.min(nbDay, this.minLeadTime)
          }
        })
        this.avgLeadTime = (this.avgLeadTime / dataSerie.length).toFixed(1)
        this.series = [{
          name: 'Réception produits',
          data: dataSerie,
        }]
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    formatReference (reference) {
      return reference.substr(0, 3) + ' ' + reference.substr(3, 3) + ' ' + reference.substr(6, 3)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/graph/WorkstationState.vue